import { render } from "./MainScene.vue?vue&type=template&id=173c6f9e"
import script from "./MainScene.vue?vue&type=script&lang=js"
export * from "./MainScene.vue?vue&type=script&lang=js"

import "./MainScene.vue?vue&type=style&index=0&id=173c6f9e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__